import { boolean, z } from "zod";
import { ReportFormat } from "../../enums/ReportFormat";
import { idSchema } from "../../utils/IdSchema";
import { requiredStringSchema } from "../../utils/RequiredStringSchema";

export const EnrollmentStatusTierReportParamsSchema = z.object({
  sourceId: idSchema(),
  sourceName: requiredStringSchema().max(250),
  projectId: idSchema().optional(),
  projectName: z.string().max(250).optional(),
  requireSignature: boolean(),
  reportFormat: ReportFormat.optional(),
});

export type EnrollmentStatusTierReportParams = z.infer<
  typeof EnrollmentStatusTierReportParamsSchema
>;
